"use strict";

define('uikit/mixins/component.mixin',['require','exports','module','underscore','backbone','jquery','./bind','./injector.mixin','../extra/rendering.manager','semantic/modules/transition'],function (require, exports, module) {
  var _ = require('underscore');
  var Backbone = require('backbone');
  var $ = require('jquery');
  var BindMixin = require('./bind');
  var InjectorMixin = require('./injector.mixin');
  var renderer = require('../extra/rendering.manager');
  require('semantic/modules/transition');
  var DISPLAY_REGEX = /display:[^;]*[ ]?[!]?(imporant|)[;]?/;
  function transitionExists() {
    var el = document.createElement('ui');
    var transEndEventNames = {
      WebkitTransition: 'webkitTransitionEnd',
      MozTransition: 'transitionend',
      OTransition: 'oTransitionEnd otransitionend',
      transition: 'transitionend'
    };
    for (var name in transEndEventNames) {
      if (el.style[name] !== undefined) {
        return {
          end: transEndEventNames[name]
        };
      }
    }
    return false;
  }
  $(function () {
    $.support.transition = transitionExists();
  });
  var ComponentMixin = _.extend({}, BindMixin, InjectorMixin, {
    normalizeMethods: Mn.normalizeMethods,
    format: {},
    allowTagChange: false,
    initialize: function initialize() {
      var self = this;
      if (this._hasComponentInitialized) {
        return;
      }
      this._hasComponentInitialized = true;
      if (!(this.el && this.el.id)) {
        this.updateElementAttributes({
          id: this.cid
        });
      }
      this._setupCollectionListeners();
      this.options = this.options || {};
      this.update = _.extend({
        visible: false,
        model: false
      }, this.update);
      if (this.forceUpdate) {
        this.forceUpdate = _.extend({
          visible: true,
          model: true,
          collection: true
        }, this.forceUpdate);
      }
      this.format = _.extend({}, this.format, this.options.format);
      InjectorMixin.initialize.apply(this, arguments);
      this.vent = _.extend({}, Backbone.Events);
      this._setupOptions();
      this._proxyInternalViewEvents();
      this.listenToOnce(this, 'before:destroy', this._onBeforeDestroy);
      this.listenToOnce(this, 'render', this._initialComponentEvents);
      this.listenTo(this, 'render', this._onRender);
      BindMixin.initialize.apply(this, arguments);
      if (this.options.visible !== false) {
        this.options.visible = true;
      }
      if (this.allowTagChange) {
        this._createLinkListener();
      }
    },
    setElement: function setElement() {
      var ret = Mn.View.prototype.setElement.apply(this, arguments);
      if (this._hasSetupComponent === true) {
        this.updateElementVisibility();
      }
      return ret;
    },
    updateElementAttributes: function updateElementAttributes(attrs) {
      for (var attr in attrs) {
        this.el.setAttribute(attr, attrs[attr]);
      }
      return this;
    },
    removeElementAttribute: function removeElementAttribute(attr) {
      this.el.removeAttribute(attr);
      return this;
    },
    updateAriaDisabledAttribute: function updateAriaDisabledAttribute() {
      if (this.getBoolOption('disabled')) {
        this.updateElementAttributes({
          'aria-disabled': 'true'
        });
      } else {
        this.removeElementAttribute('aria-disabled');
      }
      return this;
    },
    buildComponent: function buildComponent(options) {
      options = _.extend({}, options, this.getInternalViewOptions(options.name));
      return this._injectorBuildComponent(options);
    },
    _proxyInternalViewEvents: function _proxyInternalViewEvents() {
      _.each(this.getInternalViews(), function (viewName) {
        var view = this[viewName];
        if (!this._componentCanSetupProxy(viewName)) {
          return;
        }
        function callChildEvent(eventName) {
          var args = _.rest(arguments),
            childEvents = this.normalizeMethods(_.result(this, 'childEvents'));
          if (typeof childEvents !== 'undefined' && _.isFunction(childEvents[eventName])) {
            childEvents[eventName].apply(this, args);
          }
        }
        ;
        this.proxyEventsFromOption(viewName, {
          callback: callChildEvent
        });
        this.on('change:' + viewName, function (self, current, previous) {
          view = this[viewName];
          if (view instanceof Backbone.View) {
            view._shouldCallShow = true;
          }
        }, this);
      }, this);
    },
    _componentCanSetupProxy: function _componentCanSetupProxy(viewName) {
      this._internalViewProxy = this._internalViewProxy || [];
      if (this._internalViewProxy.indexOf(viewName) < 0) {
        this._internalViewProxy.push(viewName);
        return true;
      }
      return false;
    },
    proxyEventsFrom: function proxyEventsFrom(bus, options) {
      options = options || {};
      var prefix = options.withPrefix ? options.withPrefix + ':' : '',
        self = this;
      function triggerEvent(eventName) {
        var proxyName = prefix + eventName,
          args = [proxyName].concat(options.args || []).concat(_.rest(arguments));
        this.triggerMethod.apply(this, args);
        if (options.callback) {
          options.callback.apply(this, args);
        }
      }
      this.listenTo(bus, 'all', triggerEvent);
      return _.once(function () {
        self.stopListening(bus, 'all', triggerEvent);
      });
    },
    proxyEventsFromOption: function proxyEventsFromOption(optionName, options) {
      var bus,
        unbind = _.noop;
      function doProxy() {
        unbind();
        bus = this[optionName];
        if (bus && bus.listenTo) {
          unbind = this.proxyEventsFrom(bus, _.extend({
            withPrefix: optionName,
            args: [bus]
          }, options));
        }
      }
      this.on('change:' + optionName, doProxy, this);
      doProxy.call(this);
      return this;
    },
    bindOption: function bindOption(optionName, targetOptionName, targetView) {
      targetView[targetOptionName] = this[optionName];
      this.on('change:' + optionName, function () {
        targetView[targetOptionName] = this[optionName];
      }, this);
      this.listenTo(targetView, 'change:' + targetOptionName, function () {
        this[optionName] = targetView[targetOptionName];
      });
      return this;
    },
    _doesKeyChangeNeedReRender: function _doesKeyChangeNeedReRender(key, value) {
      if (this.forceUpdate) {
        return !!this.forceUpdate && this.forceUpdate[key] === true;
      }
      return this.update !== false && (this.update == null || this.update[key] !== false);
    },
    _initialComponentEvents: function _initialComponentEvents() {
      this._hasSetupComponent = true;
      this.listenTo(this.vent, 'change', function (model, key, value) {
        if (!this._needsReRender) {
          this._needsReRender = this._doesKeyChangeNeedReRender(key, value);
        }
        renderer.requestRender(_.bind(this._updateComponent, this), this.cid);
      });
      this.onFirstRender();
      this.vent.on('change:visible', function () {
        this.updateElementVisibility();
      }, this);
      if (this.visible === false) {
        this.hide({
          force: true
        });
      }
      this._injectorUpdateInternalViews();
    },
    updateElementVisibility: function updateElementVisibility() {
      if (this.visible) {
        this.show({
          force: true
        });
      } else {
        this.hide({
          force: true
        });
      }
    },
    _requestRender: function _requestRender() {
      if (!this.isRendered) {
        return;
      }
      this._needsReRender = true;
      renderer.requestRender(_.bind(this._updateComponent, this), this.cid);
    },
    _updateComponent: function _updateComponent() {
      if (!this._disableChange && !this.isDestroyed) {
        if (!this._isRendered && !this.isRendered && !this.visible) {
          return;
        }
        if (this._needsReRender) {
          this.render();
        } else {
          this.clearClassNames();
          this.updateAttributes();
        }
      }
      this._needsReRender = false;
    },
    _ensureElement: function _ensureElement() {
      if (this.allowTagChange) {
        this._verifyLink();
      }
      Backbone.View.prototype._ensureElement.apply(this, arguments);
    },
    _verifyLink: function _verifyLink() {
      var options = this.options,
        bindings = _.extend({}, this.bindings, options.bindings);
      if (!this._originalTagName) {
        this._originalTagName = this.tagName;
      }
      if (options.link || this.link) {
        this.tagName = 'a';
      } else if (options.model && bindings && bindings.link && options.model.get(bindings.link)) {
        this.tagName = 'a';
      } else {
        this.tagName = this._originalTagName;
      }
    },
    _createLinkListener: function _createLinkListener() {
      this.vent.on('change:link', function (self, link, oldLink) {
        if (!!link != !!oldLink) {
          var oldEl = this.$el;
          this.undelegateEvents();
          this.el = null;
          this._ensureElement();
          oldEl.replaceWith(this.$el);
          this._requestRender();
        }
      }, this);
    },
    _isVisible: function _isVisible() {
      return this.$el.is(":visible");
    },
    _setOption: function _setOption(key, value, external) {
      var change = false,
        oldValue = this.options[key];
      if (this.options[key] !== value) {
        change = true;
      }
      this.options[key] = value;
      if (change) {
        if (oldValue && oldValue._listenId && _.contains(this._internalViews, key)) {
          this.stopListening(oldValue);
        }
        if (external) {
          this.triggerMethod("change:" + key, this, value, oldValue);
          this.triggerMethod("change", this, key, value, oldValue);
        }
        if (!external) {
          this.vent.trigger("change:" + key, this, value, oldValue);
          this.vent.trigger("change", this, key, value, oldValue);
          this.triggerMethod("change:" + key, this, value, oldValue);
          this.triggerMethod("change", this, key, value, oldValue);
        }
      }
    },
    _setupOptions: function _setupOptions() {
      var self = this;
      this._internal = {};
      var keys = _.keys(this.constructor.prototype.options);
      if (_.indexOf(keys, 'visible') < 0) {
        keys.push('visible');
      }
      if (_.indexOf(keys, 'model') < 0) {
        keys.push('model');
      }
      if (_.indexOf(keys, 'collection') < 0) {
        keys.push('collection');
      }
      _.each(this._internalViews, function (key) {
        if (_.indexOf(keys, key) < 0) {
          keys.push(key);
        }
      });
      _.each(keys, function (key) {
        if (this.options[key] == null && this[key] != null) {
          this.options[key] = this[key];
        }
        Object.defineProperty(this, key, {
          get: function get() {
            return self.options[key];
          },
          set: function set(value) {
            self._setOption(key, value);
            return self;
          }
        });
        Object.defineProperty(this._internal, key, {
          get: function get() {
            return self.options[key];
          },
          set: function set(value) {
            self._setOption(key, value, true);
            return self;
          }
        });
      }, this);
    },
    show: function show(options) {
      var animation = false;
      if (_.isString(options)) {
        animation = options;
        options = {};
      }
      options = _.extend({
        queue: false,
        animation: animation
      }, options);
      if (!this.visible || options.force === true) {
        this._show(options);
      }
      this._internal.visible = true;
      return this;
    },
    _show: function _show(options) {
      if (options.animation && $.support.transition) {
        if (_.isBoolean(options.animation)) {
          options.animation = 'fade in';
        }
        if (options.animation.indexOf('in') < 0) {
          options.animation = options.animation.trim() + ' in';
        }
        this._transition(options);
      } else {
        if (this._hasTransitioned) {
          var style = (this.$el.attr('style') || '').replace(DISPLAY_REGEX, '');
          this.$el.attr('style', style).removeClass('hidden');
        } else {
          this.el.style.display = '';
        }
        if (options.onComplete) {
          options.onComplete.call(this.$el);
        }
      }
    },
    hide: function hide(options) {
      var animation = false;
      if (_.isString(options) || _.isBoolean(options)) {
        animation = options;
        options = {};
      }
      options = _.extend({
        queue: false,
        animation: animation
      }, options);
      if (this.visible || options.force === true) {
        this._hide(options);
      }
      this._internal.visible = false;
      return this;
    },
    _hide: function _hide(options) {
      if (options.animation && $.support.transition) {
        if (_.isBoolean(options.animation)) {
          options.animation = 'fade out';
        }
        if (options.animation.indexOf('out') < 0) {
          options.animation = options.animation.trim() + ' out';
        }
        this._transition(options);
      } else {
        if (this._hasTransitioned) {
          var style = (this.$el.attr('style') || '').replace(DISPLAY_REGEX, '');
          style += ' display: none;';
          this.$el.attr('style', style).removeClass('visible');
        } else {
          this.el.style.display = 'none';
        }
        if (options.onComplete) {
          options.onComplete.call(this.$el);
        }
      }
    },
    _transition: function _transition(options) {
      this._hasTransitioned = true;
      this.$el.transition(options);
    },
    _onRender: function _onRender() {
      this._proxyInternalViewEvents();
      this.clearClassNames();
      this.updateAttributes();
    },
    updateAttributes: function updateAttributes() {},
    clearClassNames: function clearClassNames() {
      var cache = this._classNameCache || [];
      for (var i = 0, len = cache.length, className; i < len; i++) {
        className = cache[i];
        this.$el.removeClass(className);
      }
      this._classNameCache = [];
      return this;
    },
    addClass: function addClass(className, shouldAdd) {
      var cache = this._classNameCache || (this._classNameCache = []);
      shouldAdd = arguments.length > 1 ? shouldAdd : true;
      if (shouldAdd === true) {
        cache.push(className);
        this.el.className += ' ' + String(className).trim();
      }
      return this;
    },
    getBoolOption: function getBoolOption(name) {
      return !!this.getOption(name);
    },
    serializeData: function serializeData() {
      var data = _.extend({}, this.options);
      if (this.model && this.serializeModel) {
        data.model = this.serializeModel(this.model);
      }
      if (this.collection && this.serializeCollection) {
        data.items = this.serializeCollection(this.collection);
      }
      return data;
    },
    onFirstRender: function onFirstRender() {},
    _onBeforeDestroy: function _onBeforeDestroy() {
      this.vent.stopListening();
      this.vent.off();
    },
    serializeOptions: function serializeOptions() {
      var definedOptions = this.constructor.prototype.options,
        options = {};
      _.each(definedOptions, function (v, key) {
        var value = this.getOption(key);
        if (_.isString(value) || _.isBoolean(value)) {
          options[key] = value;
        }
      }, this);
      return options;
    },
    _setupBindings: function _setupBindings() {
      var model = this.model,
        bindings = this.getOption('bindings') || {},
        ev = this._createBindingsEventObject(),
        self = this;
      _.each(bindings, function (modelField, viewField) {
        self._bindBinding(ev, self, viewField, model, modelField);
      });
      BindMixin._setupBindings.apply(this, arguments);
    },
    _createBindingsEventObject: function _createBindingsEventObject() {
      var prevEv = this._previousEventBus,
        ev = _.extend({}, Backbone.Events);
      if (prevEv) {
        prevEv.stopListening();
      }
      ev.listenTo(this, 'change:model', function (self, newModel) {
        ev.stopListening();
        self._setupBindings();
      }).listenTo(this, 'before:destroy', function () {
        ev.stopListening();
      });
      this._previousEventBus = ev;
      return ev;
    },
    _bindBinding: function _bindBinding(ev, view, viewField, model, modelField) {
      if (modelField == null || viewField == 'model') {
        return;
      }
      if (!(view instanceof Backbone.View)) {
        return;
      }
      if (!model) {
        view[viewField] = null;
        return;
      }
      ev.listenTo(model, 'change:' + modelField, function () {
        view[viewField] = model.get(modelField);
      }).listenTo(view, 'change:' + viewField, function () {
        model.set(modelField, view[viewField]);
      });
      view[viewField] = model.get(modelField);
    },
    _setupCollectionListeners: function _setupCollectionListeners() {
      this.listenTo(this, 'change:collection', function (self, value, oldValue) {
        if (this._hasSetupComponent) {
          if (oldValue) {
            this.stopListening(oldValue);
          }
          if (this.constructor.prototype._initialEvents) {
            this.constructor.prototype._initialEvents.apply(this);
          }
          if (this._renderChildren) {
            this._renderChildren();
          }
        }
        this.undelegateCollectionEvents(oldValue);
        this.delegateCollectionEvents(value);
      });
    },
    delegateCollectionEvents: function delegateCollectionEvents(collection) {
      this.bindEntityEvents(collection, this.getOption('collectionEvents'));
      _.each(this._behaviors, function (behavior) {
        behavior.bindEntityEvents(collection, behavior.getOption('collectionEvents'));
      }, this);
      return this;
    },
    undelegateCollectionEvents: function undelegateCollectionEvents(collection) {
      this.unbindEntityEvents(collection, this.getOption('collectionEvents'));
      _.each(this._behaviors, function (behavior) {
        behavior.unbindEntityEvents(collection, behavior.getOption('collectionEvents'));
      }, this);
      return this;
    }
  });
  module.exports = ComponentMixin;
});

